import React, { useContext } from 'react';

import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';

import { ProvidersContext } from './context';
import { RangeValidator as HoverRangeValidator } from './hover/range-validator';
import { SelectionRangeValidator } from './selection/range-validator';

type Props = {
	createAnalyticsEvent?: CreateUIAnalyticsEvent;
	isNestedRender?: boolean;
	rendererRef: React.RefObject<HTMLDivElement>;
};
export const AnnotationsContextWrapper = (props: React.PropsWithChildren<Props>): JSX.Element => {
	const providers = useContext(ProvidersContext);
	const { rendererRef, createAnalyticsEvent, children } = props;
	const inlineCommentProvider = providers && providers.inlineComment;
	const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
	const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;

	if (!selectionComponent && !hoverComponent) {
		return <>{children}</>;
	}

	return (
		<>
			{children}
			{!!hoverComponent && (
				<HoverRangeValidator
					createAnalyticsEvent={createAnalyticsEvent}
					rendererRef={rendererRef}
					// Ignored via go/ees005
					// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
					component={hoverComponent!}
				/>
			)}
			{!!selectionComponent && (
				<SelectionRangeValidator
					createAnalyticsEvent={createAnalyticsEvent}
					rendererRef={rendererRef}
					// Ignored via go/ees005
					// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
					selectionComponent={selectionComponent!}
				/>
			)}
		</>
	);
};
